import { apiAxios } from '../config/axios';

export const AttributionService = {
  async submitInstallAttribution(data) {
    const payload = {
      ...data,
      query_params:
        data.query_params[0] === '?'
          ? data.query_params.slice(1, data.query_params.length)
          : data.query_params,
    };
    const res = await apiAxios.post(`/attribution/install`, payload);
    return res.data;
  },
};
